<!-- ProductCreatedSuccess.vue -->
<template>
  <simple-layout>
    <ProductCreatedSuccessComp />
  </simple-layout>
</template>

<script>
import ProductCreatedSuccessComp from '@/components/add-product/ProductCreatedSuccessComp.vue';
import SimpleLayout from '@/layouts/SimpleLayout.vue';

export default {
  components: {
    SimpleLayout,
    ProductCreatedSuccessComp
  },
};
</script>

